import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { PageHero, FadeUp } from "../../components/public/Section";
import { Megaphone, Calendar, User } from "lucide-react";

export default function SearchResults() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState({ announcements: [], events: [], members: [] });
  useEffect(() => { if (q) api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setData(r.data)); }, [q]);

  const empty = !data.announcements.length && !data.events.length && !data.members.length;
  return (
    <div>
      <PageHero title={`Search Results for "${q}"`} breadcrumbs={["Home", "Search"]} />
      <section className="section container-page space-y-10">
        {empty && q && <div className="text-center text-brand-muted py-14">No results found.</div>}

        {data.announcements.length > 0 && (
          <div>
            <h3 className="font-serif text-xl font-bold mb-4 flex items-center gap-2"><Megaphone size={18} /> Announcements</h3>
            <div className="space-y-3">
              {data.announcements.map((a) => (
                <FadeUp key={a.id} className="card-elev p-4">
                  <Link to={`/announcements/${a.slug}`} className="font-semibold text-brand-text hover:text-brand-primary">{a.title}</Link>
                  <div className="text-sm text-brand-muted mt-1 line-clamp-2">{a.summary}</div>
                </FadeUp>
              ))}
            </div>
          </div>
        )}

        {data.events.length > 0 && (
          <div>
            <h3 className="font-serif text-xl font-bold mb-4 flex items-center gap-2"><Calendar size={18} /> Events</h3>
            <div className="space-y-3">
              {data.events.map((e) => (
                <FadeUp key={e.id} className="card-elev p-4">
                  <Link to={`/events/${e.slug}`} className="font-semibold text-brand-text hover:text-brand-primary">{e.title}</Link>
                  <div className="text-sm text-brand-muted mt-1">{e.venue}</div>
                </FadeUp>
              ))}
            </div>
          </div>
        )}

        {data.members.length > 0 && (
          <div>
            <h3 className="font-serif text-xl font-bold mb-4 flex items-center gap-2"><User size={18} /> Members</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {data.members.map((m) => (
                <FadeUp key={m.id} className="card-elev p-4">
                  <div className="font-semibold text-brand-text">{m.name}</div>
                  <div className="text-sm text-brand-muted">{m.specialization} · {m.hospital}</div>
                </FadeUp>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
